import { useCallback, useState } from 'react'

import { useLocaleContext } from '@src/components/locale/locale.context'
import Product from '@src/quince-site-common/src/domains/Product'
import { ProductVariantOption } from '@src/quince-site-common/src/domains/ProductVariant/BaseProductVariant'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'

import useDeviceInfo, { DEVICE_TYPES } from '../../useDeviceInfo'
import { buildAppDeepLinkUrl, buildPageUrl } from '../utils/appLink.utils'

export function useShopInAppHandler() {
  const [isAppQRModalOpen, setIsAppQRModalOpen] = useState(false)

  const deviceInfo = useDeviceInfo()
  const { locale } = useLocaleContext()

  const handleShopInApp = useCallback(
    ({ product, selectedOptions }: { product?: Product; selectedOptions?: ProductVariantOption[] }) => {
      const pageLink = buildPageUrl({ locale, product, selectedOptions })
      const appQRLink = buildAppDeepLinkUrl(pageLink)

      const isMobile = deviceInfo.deviceType === DEVICE_TYPES.MOBILE

      if (isMobile) {
        trackEvent(TELEMETRY_EVENT_NAMES.APP_EXCLUSIVE_LINK_CLICKED, {})
        window.location.href = appQRLink
      } else {
        setIsAppQRModalOpen(true)
        trackEvent(TELEMETRY_EVENT_NAMES.APP_EXCLUSIVE_MODAL_OPENED, {})
      }
    },
    [deviceInfo.deviceType, locale],
  )

  const handleCloseAppQRModal = useCallback(() => {
    setIsAppQRModalOpen(false)
  }, [])

  const handleOpenAppQRModal = useCallback(() => {
    setIsAppQRModalOpen(true)
  }, [])

  return { isAppQRModalOpen, handleShopInApp, handleCloseAppQRModal, handleOpenAppQRModal }
}
